module.exports = __webpack_public_path__ + "static/media/start-screen-unbranded.f8819da0.png";